import React from 'react';
import style from "./BackGroundLogo.module.scss";
import {Col, Row} from "antd";
import {BackGroundLogoProps} from "../../models";

const BackGroundLogo = ({step} :BackGroundLogoProps) => {
    return (
        <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                {step === 1 && <img className={style.customImage} src={require("assets/Logo/step1.png")}/>}
                {step === 2 &&<img className={style.customImage} src={require("assets/Logo/step2.png")}/>}
                {step === 3 &&<img className={style.customImage} src={require("assets/Logo/step3.png")}/>}
            </Col>
        </Row>
    );
};

export default BackGroundLogo;
